import { MealPlannerContainer } from "../../athlete-portal/nutrition/meal-planner/MealPlannerContainer";
import { AddFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/AddFoodModal";
import { BuildMealModal } from "../../athlete-portal/nutrition/meal-planner/modals/BuildMealModal";
import { CreateNewFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/CreateNewFoodModal";
import { CustomMealModal } from "../../athlete-portal/nutrition/meal-planner/modals/CustomMealModal";
import DataSourceModal from "../../athlete-portal/nutrition/meal-planner/modals/DataSourceModal";
import { DuplicateMealPlanModal } from "../../athlete-portal/nutrition/meal-planner/modals/DuplicateMealPlanModal";
import { DuplicateMealPlanWeekModal } from "../../athlete-portal/nutrition/meal-planner/modals/DuplicateMealPlanWeekModal";
import { HandleFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/HandleFoodModal";
import { MoveMealPlanModal } from "../../athlete-portal/nutrition/meal-planner/modals/MoveMealPlanModal";
import { RecipeDetailModal } from "../../athlete-portal/nutrition/meal-planner/modals/RecipeDetailModal";
import ReplaceDayFromTemplateModal from "../../athlete-portal/nutrition/meal-planner/modals/ReplaceDayFromTemplateModal";
import ReplaceOptionFromTemplateModal from "../../athlete-portal/nutrition/meal-planner/modals/ReplaceOptionFromTemplateModal";
import CopyMealPlanFromTemplateModal from "../all-templates/modals/CopyMealPlanFromTemplateModal";
import HandleMealPlanOptionNameModal from "../all-templates/modals/HandleMealPlanOptionNameModal";
import HandleMealPlanTemplateModal from "../all-templates/modals/HandleMealPlanTemplateModal";
import ModifyWithAIPlanModal from "../all-templates/modals/ModifyWithAIPlanModal";
import RateMealPlanModal from "../all-templates/modals/RateMealPlanModal";
import RegenerateMealPlanModal from "../all-templates/modals/RegenerateMealPlanModal";

const EditMealPlanController = async ({ api, res, req, locals, load }) => {
  const { query } = req;

  const { mealPlan, widget } = query;
  const planMode = query.planMode || "detailed"; // Default to "detailed" if not specified
  const modal = query.modal || {};
  const initialPromises = [
    load("mealPlan", {
      mealPlanId: mealPlan,
      proxyAthlete: null,
    }),
    load("basicMealsInformation"),
  ];

  if (locals.activeUser?.organizationId) {
    initialPromises.push(
      load("usersOrganization", {
        organizationId: locals.activeUser.organizationId,
      }),
    );
  }

  await Promise.all(initialPromises);

  //we are request it after the promise all to have the organization information already loaded
  const nextPromises = [
    load("mostUsedMealPlans"),
    load("mealPlanIsTemplate", { mealPlanId: mealPlan }),
  ];

  if (widget) {
    nextPromises.push(load("mealPlanLibraries", { widget }));
  }

  switch (modal.type) {
    case "copy-meal-plan-from-template":
    case "modify-with-ai":
      nextPromises.push(
        load("mealPlanTemplates", {
          customLimit: 1,
          customSkip: 1,
          noPagination: true,
          planMode,
        }),
        load("assignedMealPlans"),
      );
      break;
    case "replace-option-from-template":
    case "replace-day-from-template":
      nextPromises.push(
        load("mealPlanTemplates", {
          customLimit: 1,
          customSkip: 1,
          noPagination: true,
          planMode: "simplified",
        }),
      );
      break;
    case "handle-meal-plan":
      nextPromises.push(
        load("mealPlanTemplates", {
          customLimit: 1,
          customSkip: 1,
          noPagination: true,
          planMode: query.planMode || "detailed",
        }),
      );
      break;
    case "create-meal-planner-food":
    case "build-meal":
      nextPromises.push(load("customFoods"));
      break;
    case "recipe-detail":
      nextPromises.push(
        load("recipeDetails", {
          type: query.recipeType,
          recipeId: query.recipeId,
        }),
      );
      break;
    default:
      break;
  }
  await Promise.all(nextPromises);
  locals.modal = {
    "create-meal-planner-food": <AddFoodModal locals={locals} api={api} />, //main modal
    "handle-meal-planner-food": <HandleFoodModal locals={locals} />, //create-edit a food
    "create-new-food": <CreateNewFoodModal />, //modal to show 2 options (create a food or meal)
    "duplicate-meal-plan": <DuplicateMealPlanModal locals={locals} />, //duplicate a meal plan
    "duplicate-meal-plan-week": <DuplicateMealPlanWeekModal locals={locals} />, //duplicate a meal plan week
    "move-meal-plan": <MoveMealPlanModal locals={locals} />, //move a meal plan
    "custom-meal": <CustomMealModal locals={locals} />, //modal to create cutom meals (something different as "snacks", "lunch", "breakfast")
    "build-meal": <BuildMealModal locals={locals} api={api} />, //create and edit a meal
    "recipe-detail": <RecipeDetailModal locals={locals} />, //read-only recipe details
    "data-source": <DataSourceModal locals={locals} />,
    "copy-meal-plan-from-template": (
      <CopyMealPlanFromTemplateModal locals={locals} />
    ),
    "modify-with-ai": <ModifyWithAIPlanModal locals={locals} />,
    "regenerate-meal-plan": <RegenerateMealPlanModal locals={locals} />,
    "handle-meal-plan": <HandleMealPlanTemplateModal locals={locals} />,
    "handle-meal-plan-option-name": (
      <HandleMealPlanOptionNameModal locals={locals} />
    ),
    "rate-meal-plan": <RateMealPlanModal locals={locals} />,
    "replace-option-from-template": (
      <ReplaceOptionFromTemplateModal locals={locals} />
    ),
    "replace-day-from-template": (
      <ReplaceDayFromTemplateModal locals={locals} />
    ),
  }[modal.type];

  res.body = <MealPlannerContainer locals={locals} api={api} />;
};

export default EditMealPlanController;
